import { render } from "./macommande.vue?vue&type=template&id=4fa7c0d6&scoped=true"
import script from "./macommande.vue?vue&type=script&lang=js"
export * from "./macommande.vue?vue&type=script&lang=js"

import "./macommande.vue?vue&type=style&index=0&id=4fa7c0d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa7c0d6"]])

export default __exports__